import { render, staticRenderFns } from "./CreateAccessrule.vue?vue&type=template&id=3156ad84&scoped=true"
import script from "./CreateAccessrule.vue?vue&type=script&lang=js"
export * from "./CreateAccessrule.vue?vue&type=script&lang=js"
import style0 from "./CreateAccessrule.vue?vue&type=style&index=0&id=3156ad84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156ad84",
  null
  
)

export default component.exports